module.exports = __webpack_public_path__ + "img/african-farmer.fee40af4.jpg";